<template>
  <div class="card" @click.prevent="goToTicket" :class="{'bg-soft-danger': shouldHighlight}">
    <div class="card-body">
      <div class="row">
        <!-- Left column -->
        <div class="col-md-8">

          <div class="ticket-card-left-wrapper">
            <div class="left">
              <div class="avatar-sm">
                <span class="avatar-title rounded bg-soft-primary text-primary font-size-16">
                  {{ ticket.agent ? ticket.agent.name.charAt(0) : '?' }}
                </span>
              </div>
            </div>
            <div class="right">
              <b class="subject">{{ ticket.subject }}</b><br>
              <div class="property mt-1">
                <span>Axum ID:</span> {{ ticket.axum_booking_id ? ticket.axum_booking_id : '-' }}
                <span class="ml-3">Lead PAX:</span> {{
                  ticket.primary_contact ? (ticket.primary_contact.first_name + ' ' + (ticket.primary_contact.last_name || '')) :
                  '-'
                }}
              </div>
              <div class="property mt-1">
                <span v-if="whoWasLastCommunicationFrom === 'itg'">
                  Last messsage was from ITG {{ ticket.last_communication_from_itg ? ' ' + displayTimeAgo(ticket.last_communication_from_itg) : ': -' }}
                </span>
                <span v-if="whoWasLastCommunicationFrom === 'client'">
                  Last messsage was from client {{ ticket.last_communication_from_client ? ' ' + displayTimeAgo(ticket.last_communication_from_client) : ': -' }}
                </span>
              </div>
              <div class="property mt-1">
                Opened {{ displayTimeAgo(ticket.created_at) }}
              </div>
            </div>
          </div>
        </div>
        <!-- / Left column -->

        <!-- Right column -->
        <div class="col-md-4 right-properties">
          <div class="property mt-half">
            <span class="badge font-size-11 px-2 py-1 text-white mb-half"
              :style="getPriorityColourDotStyles(ticket.priority)">{{ getHumanReadableTicketPriority(ticket.priority)
              }}</span>
          </div>
          <div class="property mt-1">
            <i class="bx bx-info-circle mr-1 font-weight-bold"></i> {{ getHumanReadableTicketStatus(ticket.status) }}
            <!--            <span class="priority-colour-dot" :style="getPriorityColourDotStyles(ticket.priority)"></span> {{ getHumanReadableTicketPriority(ticket.priority) }}-->
          </div>
          <div class="property mt-1">
            <i class="bx bx-user mr-1 font-weight-bold"></i> {{ ticket.agent ? ticket.agent.name : 'Unassigned' }}
          </div>
        </div>
        <!-- / Right column -->
      </div>
    </div>
    <div v-if="incident_report" class="incident-report-bar">
      <span>
        <span :class="['badge', incident_report.closed_at ? 'badge-danger' : 'badge-success']" style="font-size: 0.9em;">
          {{ incident_report.closed_at ? 'Incident Report Closed' : 'Incident Report Open' }}
        </span>
        <span v-if="incident_report.type" :class="['badge', typeBadgeClass, 'ml-2']" style="font-size: 0.9em;">
          {{ incident_report.type }}
        </span>
        <span v-if="incident_report.itg_included_activity" class="badge badge-info ml-2" style="font-size: 0.9em;">
          ITG Included
        </span>
      </span>
      <span>
        Affected PAX: <b>{{ incident_report.incident_report_affected_paxs ? incident_report.incident_report_affected_paxs.length : 0 }}</b>
      </span>
    </div>
  </div>
</template>

<script>
import Dates from "../../mixins/Dates";
import Tickets from "../../mixins/Tickets";

export default {
  name: "TicketCard",
  props: {
    ticket: { type: Object, required: true },
    incident_report: { type: Object, default: null }
  },
  data() {
    return {
      highlightTicketsWithNoCommunicationSince: null,
      openTicketInSameWindow: false
    }
  },
  created() {
    this.highlightTicketsWithNoCommunicationSince = window.itgHighlightTicketsWithNoCommunicationSince;
    this.openTicketInSameWindow = Boolean(window.itgOpenTicketInSameWindow);
  },
  mixins: [Dates, Tickets],
  methods: {
    goToTicket() {
      let openTicketInSameWindow = Boolean(window.itgOpenTicketInSameWindow);

      // if (this.openTicketInSameWindow) {
      if (openTicketInSameWindow) {
        console.log('Opening in same window');
        this.$router.push('/tickets/' + this.ticket.id);
      } else {
        // alert('Opening ticket in new window')
        console.log('Opening in new window');
        window.open('/tickets/' + this.ticket.id, '_blank');
      }
    },

    getPriorityColourDotStyles(priority) {
      return 'background: ' + this.getPriorityColour(priority) + ';' + 'color: ' + this.getPriorityTextColour(priority) + '!important;';
    }
  },
  computed: {
    lastCommunicationFromItgMoment() {
      return window.moment(this.ticket.last_communication_from_itg);
    },

    isLastCommunicationFromItgMomentValid() {
      return this.lastCommunicationFromItgMoment.isValid();
    },

    lastCommunicationFromClientMoment() {
      return window.moment(this.ticket.last_communication_from_client);
    },

    isLastCommunicationFromClientMomentValid() {
      return this.lastCommunicationFromClientMoment.isValid();
    },

    whoWasLastCommunicationFrom() {
      // Both moments valid
      if (
        this.isLastCommunicationFromClientMomentValid
        && this.isLastCommunicationFromItgMomentValid
      ) {
        if (
          window.moment(this.lastCommunicationFromClientMoment).isAfter(this.lastCommunicationFromItgMoment)
        ) {
          return 'client';
        } else {
          return 'itg';
        }
      }

      // Only client moment valid
      if (
        this.isLastCommunicationFromClientMomentValid
        && !this.isLastCommunicationFromItgMomentValid
      ) {
        return 'client';
      }

      // Only ITG moment valid
      if (
        !this.isLastCommunicationFromClientMomentValid
        && this.isLastCommunicationFromItgMomentValid
      ) {
        return 'itg';
      }

      // Neither valid
      return null;
    },

    shouldHighlight() {
      if (!this.highlightTicketsWithNoCommunicationSince) {
        return false;
      }

      if (this.getHumanReadableTicketStatus(this.ticket.status) === 'Closed') {
        return false;
      }

      if (this.whoWasLastCommunicationFrom === 'itg') {
        if (
          window.moment().diff(this.lastCommunicationFromItgMoment, 'minutes') >= (this.highlightTicketsWithNoCommunicationSince * 60)
        ) {
          return true;
        } 
      }

      if (this.whoWasLastCommunicationFrom === 'client') {
        if (
          window.moment().diff(this.lastCommunicationFromClientMoment, 'minutes') >= (this.highlightTicketsWithNoCommunicationSince * 60)
        ) {
          return true;
        }
      }

      return false;
    },

    typeBadgeClass() {
      if (!this.incident_report || !this.incident_report.type) return 'badge-secondary';
      const type = this.incident_report.type.toLowerCase();
      if (type === 'fit') return 'badge-primary';
      if (type === 'group') return 'badge-purple';
      return 'badge-secondary';
    }
  }
}
</script>

<style lang="scss" scoped>
.mt-half {
  margin-top: 0.125rem !important;
}

.mb-half {
  margin-bottom: 0.125rem !important;
}

.card {
  transition: box-shadow 0.2s ease-in-out;
  cursor: pointer;
  margin-bottom: 0.75rem;

  &:hover {
    box-shadow: 0 0.75rem 1.5rem rgb(18 38 63 / 7%) !important;
  }
}

.card-body {
  padding: 0.9rem 1rem;
}

.property {
  font-size: 11px;

  span {
    font-weight: 500;
    margin-right: 5px;
  }
}

.ticket-card-left-wrapper {
  display: flex;

  .left {
    flex-shrink: 1;
    width: 70px;
    align-items: center;
    display: flex;
  }

  .right {
    flex: 1;
  }

  .subject {
    font-weight: 600;
    color: #2c5cc5;
  }
}

.right-properties {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.priority-colour-dot {
  border-radius: 100%;
  display: inline-block;
  width: 9px;
  height: 9px;
}

.incident-report-bar {
  background: #fafbfc;
  border-top: 1px solid #e5e7eb;
  padding: 0.5rem 1rem;
  font-size: 0.95em;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #333;
}

.badge-purple {
  background-color: #7c3aed;
  color: #fff;
}
</style>